import React, { useEffect } from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { POSTS } from '../data/site';
import { ScheduleCta } from '../components/home/CtaPostsCoupons';

export default function Blog() {
  useEffect(() => {
    document.title = 'Blog - Phoenix Roofing & Chimney NJ';
  }, []);
  return (
    <div data-testid="blog-page">
      <section className="py-20 bg-background">
        <div className="max-w-6xl mx-auto px-4">
          <h1 className="section-title">Recent posts</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
            {POSTS.map((p) => (
              <article key={p.slug} className="flex flex-col group" data-testid={`blog-card-${p.slug}`}>
                <Link to={`/${p.slug}`} className="overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-[210px] object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                </Link>
                <h2 className="font-heading font-semibold text-xl mt-5 leading-snug">
                  <Link to={`/${p.slug}`} className="hover:text-primary transition-colors">{p.title}</Link>
                </h2>
                <p className="mt-3 text-foreground/80 text-[15px]">{p.excerpt}</p>
                <span className="text-primary font-heading mt-auto pt-3">{p.category}</span>
              </article>
            ))}
          </div>
        </div>
      </section>
      <ScheduleCta />
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const post = POSTS.find((p) => p.slug === slug);

  useEffect(() => {
    if (post) document.title = `${post.title} - Phoenix Roofing & Chimney`;
  }, [post]);

  if (!post) return <Navigate to="/blog" replace />;

  return (
    <div data-testid="blog-post-page">
      <article className="py-16 max-w-3xl mx-auto px-4">
        <p className="text-primary font-heading font-semibold uppercase tracking-[0.1em] text-sm">{post.category}</p>
        <h1 className="font-heading font-semibold text-3xl md:text-4xl leading-tight mt-3">{post.title}</h1>
        <img src={post.image} alt={post.title} className="w-full h-[300px] md:h-[420px] object-cover mt-8" />
        <p className="mt-8 text-lg text-foreground/85">{post.excerpt}</p>
        <p className="mt-5 text-lg text-foreground/85">
          Phoenix Roofing & Chimney proudly serves Bergen, Passaic, Hudson, Essex, Morris, Hunterdon, Somerset, Sussex, Union, and Warren Counties. Save up to 40% on roofing services with free in-house estimates.
        </p>
        <div className="mt-10">
          <a href="/free-estimate" className="btn-cta" data-testid="post-cta">Request a free in-house Estimate</a>
        </div>
      </article>
      <ScheduleCta />
    </div>
  );
}
